// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { tbImageFromImage } from "../framework/tbImageFromImage";
import { s_profile_placeholder } from "./AssetDefinitions/ImageDefinitions";
export function PlayerData() {
    this.id = null;
    this.photo = null;
    this.name = null;
    this.image = null;
    this.imageLoaded = false;
    this.me = false;
    this.score = 0;
}
;
PlayerData.prototype.setInfo = function (data) {
    this.id = data["getID"]();
    this.photo = data["getPhoto"]();
    this.name = data["getName"]().split(' ')[0];
    this.setPlayerImage(this.photo);
};
PlayerData.prototype.setScore = function (score) {
    "use strict";
    this.score = (score === undefined) ? 0 : score;
};
PlayerData.prototype.getScore = function () {
    "use strict";
    return this.score;
};
PlayerData.prototype.setPlayerImage = function (image, callback) {
    "use strict";
    var self = this;
    var playerImage = new Image();
    playerImage.crossOrigin = 'anonymous';
    playerImage.src = image;
    playerImage.onload = function () {
        self.image = tbImageFromImage(self.id.toString(), playerImage, playerImage["width"], playerImage["height"], 0, 0);
        console.log("Image created");
        self.imageLoaded = true;
    };
    playerImage.onerror = function () {
        self.image = s_profile_placeholder;
        self.imageLoaded = true;
    };
};
PlayerData.prototype.clone = function () {
    var clone = {};
    for (var key in this) {
        clone[key] = this[key];
    }
    return clone;
};
